const navMain = document.getElementById("nav-main");
const header = document.querySelector("header");

if (navMain) {

    const menuBtn = navMain.querySelector(".menu-btn");
    const navMobile = document.getElementById("nav-mobile");
    const overlay = document.querySelector(".overlay");

    // Passive scroll listener for sticky class (for smoother scrolling)
    document.addEventListener("scroll", () => {
        header.classList.toggle("sticky", window.scrollY > 0);
    }, { passive: true });

    // Toggle menu
    function toggleMenu(open) {
        const isOpen = open ?? !navMobile.classList.contains("open");
        menuBtn.classList.toggle("open", isOpen);
        menuBtn.setAttribute("aria-expanded", isOpen);
        navMobile.classList.toggle("open", isOpen);
        navMobile.setAttribute("aria-hidden", !isOpen);
        overlay.classList.toggle("open", isOpen);
    }

    menuBtn.addEventListener("click", () => toggleMenu());
    overlay.addEventListener("click", () => toggleMenu(false));
    window.matchMedia('(min-width: 1025px)').addEventListener('change', e => {
        if (e.matches) toggleMenu(false);
    });

    // Submenu Toggle
    navMobile.querySelectorAll(".has-sub > button").forEach(btn => {
        btn.addEventListener("click", () => {
            const item = btn.parentElement;
            const isOpen = !item.classList.contains("open");
            navMobile.querySelectorAll(".has-sub").forEach(el => el.classList.remove("open"));
            item.classList.toggle("open", isOpen);
            btn.setAttribute("aria-expanded", isOpen);
        });
    });

    // Debounced Resize Stopper
    let resizeTimer;
    window.addEventListener("resize", () => {
        document.body.classList.add("resize-animation-stopper");
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.body.classList.remove("resize-animation-stopper");
        }, 400);

    }, { passive: true });

}
